import React from 'react';
import { Card, CardHeader, CardContent, Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import image from '../../../assets/img/Demo_Athlete.png';
import { getUserRole } from '../user.helpers';
import { LoggedInUser } from '../../../state/helperServices/auth/auth.interfaces';
import { UserCardAction } from './userCardAction.dumb';
import { getInitials } from '../../../helpers/initialsExtractor';
import { EmailWithIcon } from '../../../components/emailWithIcon/emailWithIcon';
import { Avatar } from '../../../components/avatar/avatar';
import { Chips } from '../../../components/chips/chips';

interface UserCardProps {
  user: any;
  onEdit?: any;
  loginUser?: LoggedInUser;
  isNetworkConnected?: boolean;
}

export const UserCard = ({
  user,
  onEdit,
  loginUser,
  isNetworkConnected,
}: UserCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Card sx={{ maxWidth: 450, borderRadius: 4 }}>
      <CardHeader
        avatar={
          <>
            {user?.firstName && user?.lastName ? (
              <Avatar
                title={getInitials(`${user?.firstName} ${user?.lastName}`)}
              />
            ) : (
              <Avatar title="" src={image} />
            )}
          </>
        }
        action={
          <UserCardAction
            user={user}
            loginUser={loginUser}
            onEdit={onEdit}
            isNetworkConnected={isNetworkConnected}
          />
        }
        title={`${user.firstName} ${user.lastName}`}
        titleTypographyProps={{
          variant: 'h6',
          color: theme.palette.text.primary,
        }}
        subheaderTypographyProps={{
          variant: 'body2',
          color: theme.palette.text.primary,
        }}
        subheader={
          <span data-testid={`user-role-${user.firstName}-${user.lastName}`}>
            {getUserRole(user?.role[0])}
          </span>
        }
      />
      <CardContent>
        <Chips
          testId={`userStatus-${user.firstName}-${user.lastName}`}
          label={user?.enabled ? t('ENABLED') : t('DISABLED')}
          variant="filled"
          color={user?.enabled ? 'success' : 'warning'}
          size="small"
          sx={{ fontSize: '11px' }}
        />
        <Box sx={{ mt: 2 }}>
          <EmailWithIcon email={user?.email} />
        </Box>
      </CardContent>
    </Card>
  );
};
